import React, { useMemo, useEffect, useState } from "react";
import moment from "moment";
import {
    MaterialReactTable,
    useMaterialReactTable,
} from "material-react-table";

import { GetBatchData } from "../../api";

const TransactionTable = ({ powerappId, selectedYear, selectedMonth }) => {
    const [noData, setNoData] = useState(true);
    const [tableData, setTableData] = useState([]);
    const [isBatchLoading, setIsBatchLoading] = useState(false);
    const [isBatchRefetching, setBatchIsRefetching] = useState(false);

    const currentDate = moment().subtract(1, "month").format("MMMM-YYYY");
    let currentDateSplit = currentDate.split("-");
    const [columnFiltersValue, setColumnFiltersValue] = useState([]);

    useEffect(() => {
        GetBatchData({
            powerapp_id: powerappId,
            year: selectedYear,
            month: selectedMonth,
        })
            .then((res) => {
                if (res.status) {
                    setTableData(res.data);
                    if (res.data.length == 0) {
                        setNoData(true);
                    } else {
                        setNoData(false);
                    }
                }
            })
            .catch((err) => {});
    }, [selectedYear, selectedMonth]);

    const columns = useMemo(
        () => [
            {
                accessorKey: "batch_year",
                id: "batchYear",
                header: "Batch Year",
                size: 150,
            },
            {
                accessorKey: "batch_month",
                id: "batchMonth",
                header: "Batch Month",
                size: 150,
            },
            {
                accessorKey: "bhid",
                header: "BHID",
                size: 150,
                enableColumnFilter: false,
            },
            {
                accessorKey: "batch_number",
                header: "BatchNumber",
                size: 200,
                enableColumnFilter: false,
            },
            {
                accessorKey: "terminal_id",
                header: "TerminalID",
                size: 150,
                enableColumnFilter: false,
            },
            {
                accessorKey: "trans_cnt",
                header: "TransCnt",
                size: 150,
                enableColumnFilter: false,
            },
            {
                accessorKey: "key_entry_cnt",
                header: "KeyEntryCnt",
                size: 150,
                enableColumnFilter: false,
            },
            {
                accessorKey: "sales",
                header: "Sales",
                size: 150,
                enableColumnFilter: false,
            },
            {
                accessorKey: "returns",
                header: "Returns",
                size: 150,
                enableColumnFilter: false,
            },
            {
                accessorKey: "net_amt",
                header: "NetAmt",
                size: 150,
                enableColumnFilter: false,
            },
            {
                accessorKey: "adjustment_amt",
                header: "AdjustmentAmt",
                size: 150,
                enableColumnFilter: false,
            },
        ],
        [],
    );

    return (
        <div>
            {noData ? (
                <></>
            ) : (
                <MaterialReactTable
                    columns={columns}
                    data={tableData}
                    enableGlobalFilter={false}
                    enableExpandAll={false}
                    enablePagination={true}
                    enableColumnFilters={false}
                    showColumnFilters={false}
                    onColumnFiltersChange={setColumnFiltersValue}
                    state={{
                        isLoading: isBatchLoading,
                        isRefetching: isBatchRefetching,
                    }}
                    initialState={{
                        showColumnFilters: false,
                    }}
                    muiExpandButtonProps={({ row }) => ({
                        sx: {
                            transform: row.getIsExpanded()
                                ? "rotate(180deg)"
                                : "rotate(-90deg)",
                            transition: "transform 0.2s",
                        },
                    })}
                    muiTablePaperProps={({ table }) => ({
                        style: {
                            marginTop: table.getState().isFullScreen
                                ? "100px"
                                : undefined,
                        },
                    })}
                    renderDetailPanel={({ row }) => {
                        return (
                            <div key={row.id}>
                                <table className="detailRow">
                                    <tr>
                                        <th>Card Type</th>
                                        <th>Code</th>
                                        <th>Transaction Date</th>
                                        <th>Key Entry</th>
                                        <th>Cardholder Acct Number</th>
                                        <th>Authorization Number</th>
                                        <th>Reference Number</th>
                                        <th>Trans Amt</th>
                                        <th>Voucher</th>
                                        <th>DDID</th>
                                        <th>Net Amt</th>
                                        <th>Adjustment Amt</th>
                                        <th>Reject Reason</th>
                                    </tr>
                                    {row.original.batches_data_details.map(
                                        (value, key) => {
                                            return (
                                                <tr key={key}>
                                                    <td>{value.card_type}</td>
                                                    <td>{value.code}</td>
                                                    <td>
                                                        {value.transaction_date}
                                                    </td>
                                                    <td>{value.key_entry}</td>
                                                    <td>
                                                        {
                                                            value.cardholder_acct_number
                                                        }
                                                    </td>
                                                    <td>
                                                        {
                                                            value.authorization_number
                                                        }
                                                    </td>
                                                    <td>
                                                        {value.reference_number}
                                                    </td>
                                                    <td>{value.trans_amt}</td>
                                                    <td>{value.voucher}</td>
                                                    <td>{value.ddid}</td>
                                                    <td>{value.net_amt}</td>
                                                    <td>{value.adj_amt}</td>
                                                    <td>
                                                        {value.reject_reason}
                                                    </td>
                                                </tr>
                                            );
                                        },
                                    )}
                                </table>
                            </div>
                        );
                    }}
                ></MaterialReactTable>
            )}
        </div>
    );
};

export default TransactionTable;
